import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/loading.gif'
import _imports_1 from '../assets/banner-success.svg'


const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = { class: "draft" }
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "button-area" }
const _hoisted_5 = { class: "upload_progress" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  src: _imports_1,
  class: "uploaded_img"
}

import { onMounted, onBeforeUnmount, ref } from "vue";
import CommonButton from "./CommonButton.vue";
import { useRoute, useRouter } from "vue-router";
import { ProjectStore } from "../store/ProjectStore";
import { CommonStore } from "../store/CommonStore";
import { MEDIA_TYPE } from "../consts/common";
// import Toast from "./Toast.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Draft',
  setup(__props) {

const content = ref("");
const projectStore = ProjectStore();
const commonStore = CommonStore();
const router = useRouter();
const route = useRoute();
// const FileListUploaded = ref(false)
const mediaType = ref(0);
const loading = ref(false);
const files = ref(new Array<number>());
const fileAllUploadedFlag = ref(false);

onMounted(() => {
  mediaType.value = route.query.mediaType ? +route.query.mediaType : 0;
  // 下書き再提出の場合は前回入力分の下書き内容を反映する
  // content.value = String(route.query.content || '')
  content.value = projectStore.draftBeforeChecked;
  // if (!content.value) {
  //   content.value = String(route.query.hashtag|| '')
  // }

  if (mediaType.value != MEDIA_TYPE.YOUTUBE) {
    commonStore.setToast({
      showToast: true,
      message: `ファイルアップロード中です `,
      state: 0,
    });
  } else {
    fileAllUploadedFlag.value = true;
  }
});
onBeforeUnmount(() => {
  // ファイルアップロード中にブラウザバックした場合、アップロード済のファイルをstoreから削除、API通信とめる
  // 「ファイルアップロード中です」トースター非表示にする
  if (!fileAllUploadedFlag.value) {
    projectStore.setBackToUploadFile(true);
    commonStore.setToast({
      showToast: false,
      message: "ファイルアップロードを中止しました",
      timeout: 1000,
      state: 0,
    });
    // 全てアップロード済だった場合はfalseにする
    projectStore.setFileAllUploaded(false);
    // 結果リセット
    projectStore.resetFileUploadResult();
  }
});
async function sendDraft() {
  loading.value = true;
  projectStore.fileUploadResult.forEach(async(v) => {
     files.value.push(v.id);
  });

  const url = mediaType.value == MEDIA_TYPE.YOUTUBE ? content.value : "";
  // 下書きを送信する
  await projectStore
    .sendDraft({ content: content.value, resources: files.value, url: url })
    .then((v) => {
      loading.value = false;
      if (!v) return;
      projectStore.setDraftBeforeChecked("");
      if (mediaType.value != MEDIA_TYPE.YOUTUBE) {
        router.go(-2);
      } else {
        router.go(-1);
      }
    });
}

function setPlaceholder(): string {
  if (mediaType.value == MEDIA_TYPE.YOUTUBE) {
    return "https://youtube.com/";
  } else {
    return "投稿予定文章";
  }
}
function FileListUploaded() {
  // youtubeの場合はファイルアップロードなないためtrue
  if (route.query.mediaType) {
    return true;
  } else if (!route.query.mediaType && projectStore.fileAllUploaded) {
    if (fileAllUploadedFlag.value) return true;
    commonStore.setToast({
      showToast: false,
      message: "ファイルアップロード中です",
      timeout: 100,
      state: 0,
    });
    commonStore.setToast({
      showToast: true,
      message: "ファイルアップロード完了しました",
      timeout: 2000,
      state: 0,
    });
    fileAllUploadedFlag.value = true;
    return true;
  } else if (
    window.history.state.back == "/upload-file" &&
    !projectStore.fileAllUploaded
  ) {
    return false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[3] || (_cache[3] = [
          _createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
        ])))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      class: _normalizeClass([loading.value ? 'l-modal__bg' : ''])
    }, null, 2 /* CLASS */),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("p", null, "投稿予定文章", 512 /* NEED_PATCH */), [
        [_vShow, mediaType.value != _unref(MEDIA_TYPE).YOUTUBE]
      ]),
      _withDirectives(_createElementVNode("p", null, " 限定公開で投稿した動画のURLを入力してください ", 512 /* NEED_PATCH */), [
        [_vShow, mediaType.value == _unref(MEDIA_TYPE).YOUTUBE]
      ]),
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((content).value = $event)),
        class: _normalizeClass([
        mediaType.value != _unref(MEDIA_TYPE).YOUTUBE ? 'draft-text-area' : 'url-area',
      ]),
        required: "",
        placeholder: setPlaceholder()
      }, null, 10 /* CLASS, PROPS */, _hoisted_3), [
        [_vModelText, content.value]
      ]),
      _createElementVNode("div", _hoisted_4, [
        (mediaType.value != _unref(MEDIA_TYPE).YOUTUBE)
          ? (_openBlock(), _createBlock(CommonButton, {
              key: 0,
              data: {
          status: content.value && FileListUploaded() ? 0 : 2,
          button: !FileListUploaded()
            ? `ファイルアップロード中 ${
                _unref(projectStore).fileUploadResult.length
              } / ${
                _unref(projectStore).fileUploadList.get(_unref(projectStore).selectedId)?.length
              }`
            : `下書きを送信する`,
        },
              onClick: _cache[1] || (_cache[1] = ($event: any) => (content.value && FileListUploaded() ? sendDraft() : ''))
            }, null, 8 /* PROPS */, ["data"]))
          : (_openBlock(), _createBlock(CommonButton, {
              key: 1,
              data: {
          status: content.value ? 0 : 2,
          button: `下書きを送信する`,
        },
              onClick: _cache[2] || (_cache[2] = ($event: any) => (content.value ? sendDraft() : ''))
            }, null, 8 /* PROPS */, ["data"]))
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(projectStore).fileUploadList.get(
          _unref(projectStore).selectedId
        ), (file, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "upload_progress_img_wrap",
            key: index
          }, [
            _createElementVNode("img", {
              src: file.display
            }, null, 8 /* PROPS */, _hoisted_6),
            (index < _unref(projectStore).fileUploadResult.length)
              ? (_openBlock(), _createElementBlock("img", _hoisted_7))
              : _createCommentVNode("v-if", true)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})